function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);}var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useState } from 'react';
import { Checkbox } from 'flowbite-react';
import { isString, sortBy } from 'lodash';
import { usePopper } from 'react-popper';
import { Popover, Transition } from '@headlessui/react';
import { XMarkIcon, PlusCircleIcon } from '@heroicons/react/20/solid';
import { t, Translate } from "../../../I18N";
import { Pill } from "../UI";











const renderChild = (child, className) =>
isString(child) ? /*#__PURE__*/_jsx(Translate, { className: className || '' }, void 0, child) : child;

const MultiSelect = ({
  label,
  options,
  disabled,
  onChange = () => {},
  placeholder = 'No options'
}) => {
  const [optionsState, setOptionsState] = useState(sortBy(options, 'label'));
  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: 'bottom-start',
    strategy: 'absolute'
  });

  const selectedOptions = optionsState.filter((option) => option.selected);

  return /*#__PURE__*/(
    _jsx("div", { "data-testid": "multiselect" }, void 0, /*#__PURE__*/
    _jsx(Popover, { className: "relative border rounded-lg border-gray-50" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex justify-between p-2 border-b bg-gray-50 border-gray-50" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "text-base text-indigo-700" }, void 0, renderChild(label)), /*#__PURE__*/
    _jsx("div", { className: "left-0" }, void 0, /*#__PURE__*/
    React.createElement(Popover.Button, {
      ref: setReferenceElement,
      className: "text-primary-700 disabled:text-primary-300",
      disabled: disabled }, /*#__PURE__*/

    _jsx("span", { className: "sr-only" }, void 0, t('System', 'Select', null, false)), /*#__PURE__*/
    _jsx(PlusCircleIcon, { className: "w-6 text-lg" })
    )
    )
    ), /*#__PURE__*/

    _jsx(Transition, {
      enter: "transition duration-100 ease-out",
      enterFrom: "transform scale-95 opacity-0",
      enterTo: "transform scale-100 opacity-100",
      leave: "transition duration-75 ease-out",
      leaveFrom: "transform scale-100 opacity-100",
      leaveTo: "transform scale-95 opacity-0" }, void 0, /*#__PURE__*/

    React.createElement(Popover.Panel, _extends({
      ref: setPopperElement,
      style: styles.popper
      // eslint-disable-next-line react/jsx-props-no-spreading
    }, attributes.popper, {
      as: "div" }), /*#__PURE__*/

    _jsx("ul", { className: "max-w-md p-2 overflow-y-auto bg-white rounded shadow-md max-h-56 w-fit" }, void 0,
    optionsState.map((option) => /*#__PURE__*/
    _jsx("li", { className: "flex gap-2 py-1 align-top" }, option.label, /*#__PURE__*/
    _jsx(Checkbox, {
      className: "cursor-pointer",
      id: option.value,
      checked: Boolean(option.selected),
      onChange: (e) => {
        const isChecked = e.target.checked;
        const selected = optionsState.map((opt) => {
          if (opt.value === option.value) {
            return _objectSpread(_objectSpread({}, opt), {}, { selected: isChecked });
          }
          return opt;
        });
        setOptionsState(selected);
        onChange(selected);
      } }
    ), /*#__PURE__*/
    _jsx("label", { className: "cursor-pointer", htmlFor: option.value }, void 0,
    option.label
    )
    )
    )
    )
    )
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "flex flex-wrap gap-2 px-5 py-4 min-h-fit" }, void 0,
    selectedOptions.length ?
    selectedOptions.map((option) => /*#__PURE__*/
    _jsx(Pill, { color: "gray", className: "flex flex-row mb-2" }, option.value, /*#__PURE__*/
    _jsx("span", { className: "flex items-center" }, void 0, option.label), /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: "content-center justify-center ml-1 font-bold text-gray-400",
      disabled: disabled,
      onClick: () => {
        const selected = optionsState.map((opt) => {
          if (opt.value === option.value) {
            return { value: opt.value, label: opt.label };
          }
          return opt;
        });
        setOptionsState(selected);
        onChange(selected);
      } }, void 0, /*#__PURE__*/

    _jsx(XMarkIcon, { className: "w-6 text-lg" })
    )
    )
    ) :
    renderChild(placeholder, 'text-gray-500')
    )
    ));

};


export { MultiSelect };